export default __webpack_public_path__ + "static/media/knowWHatDizlogcanOffer.20564f4e.png";